import { Theme } from '@chakra-ui/react'
import { DeepPartial } from '../../../common/types'

interface NucbaButton extends DeepPartial<Theme['components']['Button']> {}

export const Button: NucbaButton = {
  baseStyle: {
    borderRadius: '8px',
    fontWeight: '600',
    transitionDuration: '50ms',
  },
}
